import React, { useContext, useEffect, useState } from 'react';

import { Field } from 'formik'
import { TextField } from 'formik-material-ui';

import {
    Grid,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography
} from '@material-ui/core';

import { 
    FieldError 
} from '../../../../common';

import { CustomerRequestContext } from '../../CustomerRequestContext';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
    invalidField: {        
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1)
    }
}));

export const BankMainInfoForm = (props) => {
    const classes = useStyles();

    const {
        state
    } = useContext(CustomerRequestContext);

    /*const {
        isBankInfoRequired
    } = state;*/

    return (
        <Card className={classes.card}>
            <CardHeader title="Bank information" />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="bankName"
                            label="Bank name"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="bankName" errors={state.errors} />
                    </Grid>
                    <Divider style={{ width:"100%" }}/>
                    <Grid item xl={6} md={6} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="bankIBAN"
                            label="IBAN"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="bankIBAN" errors={state.errors} />
                    </Grid>
                    <Grid item xl={6} md={6} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="swiftBic"
                            label="SWIFT/BIC"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="swiftBic" errors={state.errors} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}